module.exports = __webpack_public_path__ + "img/room-info.41ede635.svg";